import {
  mergeConfig,
  wrapAsDerivedFromMeasurementsConfig as wrap,
} from 'Components/Worksheets/Core/Helpers/configHelpers';
import getMoistureContentDerivedFromMeasurementsConfig from 'Components/Worksheets/MoistureContentWorksheet/derivedFromMeasurementsConfig';

const getDerivedFromMeasurementsConfig = (prefix: string) =>
  mergeConfig(
    {
      /**
       * TODO: Readability of InitialDryMass can be derived from many different measurements depending on
       * the source of the dry mass.
       */
      //[`${prefix}.Masses.InitialDryMass`]: wrap(),
      [`${prefix}.Masses.WashedDryMass`]: wrap([
        //TODO: also depends on Container Mass (when measured rather than tared to zero)
        `${prefix}.Masses.MeasuredWashedConstantDryMass.DryingTray.DryMassReadings.DrySoilAndContainerMass`,
      ]),
      [`${prefix}.Masses.WashingsDryMass`]: wrap([
        //TODO: also depends on the Dry Material Mass before washing (InitialDryMass).
        `${prefix}.Masses.MeasuredWashedConstantDryMass.DryingTray.DryMassReadings.DrySoilAndContainerMass`,
      ]),
    },
    getMoistureContentDerivedFromMeasurementsConfig(`${prefix}.Masses.MeasuredWashedConstantDryMass`)
  );

export default getDerivedFromMeasurementsConfig;
